<template>
  <el-dialog title="商品日志" :visible.sync="dialogVisible" width="90%">
    <ProdLog />
  </el-dialog>
</template>

<script>
import ProdLog from '@distributor/prod/log/index.vue';

export default {
  components: {
    ProdLog
  },
  data() {
    return {
      dialogVisible: false,
    }
  },
  methods: {
    method_open() {
      this.dialogVisible = true;
    },
  }
}
</script>

<style lang="scss" scoped>

</style>